var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { TextField as RmwcTextField } from '@rmwc/textfield';
/**
 * Text field component. Text fields allow users to input, edit, and select text.
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.4.0/content/components/textfield.md
 */
export default function TextField(props) {
    return React.createElement(RmwcTextField, __assign({}, props));
}
//# sourceMappingURL=TextField.js.map